export const PRIMARY = "#0b3d87";
export const ALL_CHARTS_TAB_ID = "__all__";
export const ALL_CHARTS_TAB_LABEL = "Mostra tutti";
